import React from 'react';

import "./ImageTitleContent.css";

export default function ImageTitleContent(props) {

    const image = props.image;
    const title = props.title;
    const text = props.text;

    return(
        <React.Fragment>
            <div
                className={"image-title-content-div default-margin-top-xlarge image-title-max-width"}
            >
                <div
                    // style={{
                    //     maxWidth: "600px",
                    //     maxHeight: "400px"
                    // }}
                >
                    <img
                        src={image}
                        alt={title}
                        width={"100%"}
                    />
                </div>
                <div
                    className={"default-font-bold default-font-color-dark default-font-huge"}
                >
                    {title}
                </div>
                <div
                    style={{
                        paddingLeft: "15px",
                        paddingRight: "15px",
                    }}
                    className={"default-font-color-dark default-margin-top-xlarge default-font-xlarge"}
                >
                    {text}
                </div>
            </div>

        </React.Fragment>
    )

}